import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'placaFormat' })
export class PlacaFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return ''
    const v = value.toUpperCase().replace(/[^A-Z0-9-]/g, '')
    if (v.includes('-')) return v
    if (v.length >= 7) return v.slice(0,3) + '-' + v.slice(3)
    return v
  }
}

